import http from '@/api/http'

export default {
  activate ( token ) {
    return http({ url: '/auth/activate', method: 'post', data: { token: token } })
  },
  login ( email, password ) {
    return http({ url: '/auth/login', method: 'post', data: { email: email, password: password } })
  },
  register (data) {
    return http({ url:'/auth/register', method: 'post', data: data })
  },
  logout () {
    return http({ url: '/auth/logout', method: 'post' })
  },
  refresh () {
    return http({ url: '/auth/refresh', method: 'post' })
  },
  user () {
    return http({ url: '/auth/user', method: 'post' })
  },
  userUpdate (data) {
    return http({ url: '/user/update', method: 'post', data: data })
  },
  delete () {
    return http({ url: '/user/delete', method: 'post' })
  },
  socialLogin(data){
    return http({url:'/auth/social-login', method:'post', data})
  }
}
